import { defaultHostPoolUuid, extremeHostPoolUuid, fasterHostPoolUuid } from "@/mock-api/data/adminHostPoolExample.ts";
import {
    defaultStoragePoolUuid,
    extremeStoragePoolUuid,
    fasterStoragePoolUuid,
} from "@/mock-api/data/adminStoragePoolExample.ts";
import { robin } from "@/mock-api/randomTypes.ts";
import { generateUuid } from "@/mock-api/requestUtils.ts";
import { withGlobalSeed } from "@/utils/random.ts";
import type { AdminHost } from "@warrenio/api-spec/spec.oats.gen";
import { times } from "remeda";

export const defaultHostUuid = "33473252-4131-5a43-3231-303830464a52";

const hostPools = [extremeHostPoolUuid, defaultHostPoolUuid, fasterHostPoolUuid];
const storagePools = [extremeStoragePoolUuid, defaultStoragePoolUuid, fasterStoragePoolUuid];

function wave(position: number, frequency: number, base: number, amplitude: number, phase = 0): number {
    return base + Math.sin(position * frequency + phase) * amplitude;
}

function generateMockData(count: number) {
    return withGlobalSeed(890982, () =>
        times(count, (i): AdminHost => {
            const id = i + 1;
            const usable_vcpu_amount = 270;
            const usable_vmem_amount = 701;

            const allocated_vcpu = wave(i, 0.3, 0.7, 0.3) * usable_vcpu_amount;
            const allocated_vmem = wave(i, 0.5, 0.8, 0.2, 0.5) * usable_vmem_amount;

            const is_maintenance = i % 17 === 10;

            return {
                allocated_vcpu,
                allocated_vmem,
                cpu_info: {
                    nproc: 72,
                    cpu_model: "85",
                    cpu_model_name: "Intel(R) Xeon(R) Gold 6154 CPU @ 3.00GHz",
                    libvirt_cpu_model: "Skylake-Server-IBRS",
                },
                created_at: "2023-10-12 10:47:42",
                host_pool_id: 12345,
                id,
                ip: `10.0.6.${100 + i}`,
                is_accepting_workloads: !is_maintenance,
                is_deleted: false,
                is_maintenance,
                is_offline: false,
                name: `wrn-loc-hv${id}`,
                os: i % 5 === 0 ? "windows" : "linux",
                pool_cpu_model: "Skylake-Server-IBRS",
                pool_name: `Pool Tier ${(i % 3) + 1}`,
                pool_uuid: robin(hostPools, i),
                status: 1,
                storage_pool_uuid: robin(storagePools, i),
                total_cpus: 108,
                total_mem_gb: 768,
                updated_at: "2025-11-25 05:56:37",
                usable_vcpu_amount,
                usable_vmem_amount,
                uuid: i === 0 ? defaultHostUuid : generateUuid(),
                vcpu_free: usable_vcpu_amount - allocated_vcpu,
                vmem_free: usable_vmem_amount - allocated_vmem,
            };
        }),
    );
}

export const adminHostExample: AdminHost[] = generateMockData(100);

export const adminHostExample2: AdminHost[] = generateMockData(10);

// cspell:words Skylake
